// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__8VqmW","footer":"ModalFilter_footer__13-rm"};